<script lang="ts">
  import { AppState } from '../../etc/stores';
  const { quaternary, secondary, firstStopColor } =
    $AppState.theme.colors.illustration;
</script>

<svg
  width="88"
  height="88"
  viewBox="0 0 88 88"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="44" cy="44" r="44" fill="url(#paint0_linear_4747:39111)" />
  <path
    d="M43.9999 70.6667C58.7275 70.6667 70.6666 58.7276 70.6666 44C70.6666 29.2724 58.7275 17.3334 43.9999 17.3334C29.2723 17.3334 17.3333 29.2724 17.3333 44C17.3333 58.7276 29.2723 70.6667 43.9999 70.6667Z"
    fill="url(#paint1_linear_4747:39111)"
  />
  <path
    d="M45.8855 31.4477C45.3854 30.9476 44.7072 30.6666 43.9999 30.6666C43.2927 30.6666 42.6144 30.9476 42.1143 31.4477C41.6142 31.9478 41.3333 32.626 41.3333 33.3333V46.6666C41.3333 47.3739 41.6142 48.0521 42.1143 48.5522C42.6144 49.0523 43.2927 49.3333 43.9999 49.3333C44.7072 49.3333 45.3854 49.0523 45.8855 48.5522C46.3856 48.0521 46.6666 47.3739 46.6666 46.6666V33.3333C46.6666 32.626 46.3856 31.9478 45.8855 31.4477Z"
    fill="white"
  />
  <path
    d="M42.1143 56.5522C42.6144 57.0523 43.2927 57.3333 43.9999 57.3333C44.7072 57.3333 45.3854 57.0523 45.8855 56.5522C46.3856 56.0521 46.6666 55.3739 46.6666 54.6666C46.6666 53.9594 46.3856 53.2811 45.8855 52.781C45.3854 52.2809 44.7072 52 43.9999 52C43.2927 52 42.6144 52.2809 42.1143 52.781C41.6142 53.2811 41.3333 53.9594 41.3333 54.6666C41.3333 55.3739 41.6142 56.0521 42.1143 56.5522Z"
    fill="white"
  />
  <defs>
    <linearGradient
      id="paint0_linear_4747:39111"
      x1="44"
      y1="0"
      x2="44"
      y2="88"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color={firstStopColor} />
      <stop offset="1" stop-color={firstStopColor} stop-opacity="0" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_4747:39111"
      x1="60.036"
      y1="-51.5555"
      x2="6.4266"
      y2="-45.6474"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={secondary} />
      <stop offset="1" stop-color={quaternary} />
    </linearGradient>
  </defs>
</svg>
